import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Divider, FormControlLabel, Stack, Typography } from '@mui/material';

import { Modal } from 'components/Modal';

import { useLotSuppliers } from '../api/getLotSuppliers';
import { useUpdateLotSuppliers } from '../api/updateLotSuppliers';

export const LotSuppliersModal = ({ frameworkAgreementId, lot, handleClose, onSaved }) => {
  const open = !!lot;
  const [all, setAll] = useState(false);
  const [selected, setSelected] = useState([]);

  const { data: suppliers, isLoading } = useLotSuppliers(frameworkAgreementId, lot?.lot_id, {
    enabled: open,
    cacheTime: 0,
  });
  const { mutateAsync: updateLotSuppliers } = useUpdateLotSuppliers(
    frameworkAgreementId,
    lot?.lot_id,
    () => {
      onSaved();
      handleClose();
    }
  );

  useEffect(() => {
    if (open && suppliers) {
      setAll(lot.all_suppliers);
      setSelected(
        suppliers
          .filter((supplier) => lot.all_suppliers || supplier.selected)
          .map(({ fac_id }) => fac_id)
      );
    }
  }, [open, suppliers, lot]);

  const allIds = suppliers?.map(({ fac_id }) => fac_id) ?? [];

  const toggleAll = () => {
    setAll(!all);
    setSelected(all ? [] : allIds);
  };

  const toggle = (facId) => {
    setAll(false);
    setSelected((current) =>
      current.includes(facId) ? current.filter((id) => id !== facId) : [...current, facId]
    );
  };

  const onSave = () => {
    updateLotSuppliers({ all, fac_ids: all ? [] : selected }).catch(() => {});
  };

  return (
    <Modal title="Lot suppliers" open={open} handleClose={handleClose}>
      <Stack gap={1} sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={all}
              indeterminate={!all && selected.length > 0 && selected.length < allIds.length}
              onChange={toggleAll}
            />
          }
          label={<Typography fontWeight="bold">All suppliers</Typography>}
        />
        <Divider />
        {!isLoading && suppliers?.length === 0 && (
          <Typography color="text.secondary">This agreement has no suppliers yet.</Typography>
        )}
        {suppliers?.map(({ fac_id, name, type }) => (
          <FormControlLabel
            key={fac_id}
            control={
              <Checkbox checked={selected.includes(fac_id)} onChange={() => toggle(fac_id)} />
            }
            label={type === 'group' ? `${name} (consortium group)` : name}
          />
        ))}
      </Stack>

      <Stack direction="row" gap={3} justifyContent="center">
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onSave} disabled={isLoading}>
          Save
        </Button>
      </Stack>
    </Modal>
  );
};
